import { render, staticRenderFns } from "./dashboard-row.vue?vue&type=template&id=7f0a1da6"
import script from "./dashboard-row.vue?vue&type=script&lang=js"
export * from "./dashboard-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports